import moment from "moment";

const calculateWeeklyProfit = (data, headerIndexes, productCode = null) => {
  const lastWeekStart = moment("11/30/2024", "MM/DD/YYYY");
  const lastWeekEnd = moment("12/06/2024", "MM/DD/YYYY");
  
  const prevWeekStart = moment("12/07/2024", "MM/DD/YYYY");
  const prevWeekEnd = moment("12/13/2024", "MM/DD/YYYY");

  const getProfit = (tour) => {
    const type = tour[headerIndexes["TYPE (labels)"]];
    const price = parseFloat(tour[headerIndexes["price"]]) || 0;
    const guideCharge = parseFloat(tour[headerIndexes["guide charge"]]) || 0;
    const transportCharge = parseFloat(tour[headerIndexes["transport charge"]]) || 0;
    const participants = parseInt(tour[headerIndexes["Participants (number)"]], 10) || 0;

    if (type === "Booklet") return price;
    if (type === "Private") return price - (guideCharge + transportCharge);
    if (type === "Group") return (participants * price) - guideCharge;
    return 0;
  };

  const calculateProfitByWeek = (start, end) => {
    return data.reduce((acc, tour) => {
      let startDate = moment(tour[headerIndexes["Start Date"]], "YYYY-MM-DD");
      if (!startDate.isValid()) {
        startDate = moment(tour[headerIndexes["Start Date"]], "MM/DD/YYYY");
      }
      if (!startDate.isValid()) return acc;

      // Check date range and product code if provided
      if (
        startDate.isBetween(start, end, null, "[)") &&
        (!productCode || tour[headerIndexes["Product Code"]] === productCode)
      ) {
        const type = tour[headerIndexes["TYPE (labels)"]];
        const profit = getProfit(tour);
        acc[type] = (acc[type] || 0) + profit;
        acc.Total = (acc.Total || 0) + profit;
      }

      return acc;
    }, { Booklet: 0, Private: 0, Group: 0, Total: 0 });
  };

  const lastWeekProfit = calculateProfitByWeek(lastWeekStart, lastWeekEnd);
  const prevWeekProfit = calculateProfitByWeek(prevWeekStart, prevWeekEnd);

  Object.keys(lastWeekProfit).forEach(key => {
    lastWeekProfit[key] = parseFloat(lastWeekProfit[key].toFixed(2));
    prevWeekProfit[key] = parseFloat(prevWeekProfit[key].toFixed(2));
  });

  const calculateChange = (current, previous) => {
    if (previous === 0) return current === 0 ? 0 : 100;
    return parseFloat(((current - previous) / Math.abs(previous) * 100).toFixed(2));
  };

  const profitChange = {
    Booklet: calculateChange(lastWeekProfit.Booklet, prevWeekProfit.Booklet),
    Private: calculateChange(lastWeekProfit.Private, prevWeekProfit.Private),
    Group: calculateChange(lastWeekProfit.Group, prevWeekProfit.Group),
    Total: calculateChange(lastWeekProfit.Total, prevWeekProfit.Total),
  };

  const result = { lastWeekProfit, prevWeekProfit, profitChange };

  return result;
};

export default calculateWeeklyProfit;
